import { API_URL } from '@/config';

// Utility function to get the full image URL
export const getImageUrl = (url) => {
  if (!url) return null;
  
  // If it's already a full URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // Get the current origin for production deployments
  const baseUrl = typeof window !== 'undefined' && window.location.hostname !== 'localhost' 
    ? window.location.origin 
    : API_URL;
  
  // Convert old /uploads/ paths to /api/files/
  if (url.startsWith('/uploads/')) {
    const filename = url.replace('/uploads/', '');
    return `${baseUrl}/api/files/${filename}`;
  }
  
  // If it's an API path, use base URL
  if (url.startsWith('/api/')) {
    return `${baseUrl}${url}`;
  }
  
  // For any other path, assume it's relative to backend
  return `${baseUrl}${url}`;
};

export default getImageUrl;
